import { useActions } from 'components/VisualStudioPlayground/VisualEditor/hooks/useActions'
import { Text } from 'blaze-ui/Text/Text'
import { Button } from 'blaze-ui/Button/Button'
import { ArrangeBackward, ArrangeForward, ArrangeToBack, ArrangeToFront } from 'blaze-ui/icons'
import Styles from '../ShapesTab.module.scss'
import { Alignment } from './Alignment'
import { Rotation } from './Rotation'
import { track } from '@tldraw/tldraw'
import { useEditor } from 'components/VisualStudioPlayground/VisualEditorContext'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

const Order = () => {
  const actions = useActions()
  const { isMobile } = useResponsiveDesign()

  return (
    <div className={Styles.textSection}>
      <Text variant="smallList">Order</Text>
      <div className={Styles.buttonsGrid}>
        <Button
          variant="secondary"
          size={isMobile ? 'lg' : 'md'}
          frontIcon={ArrangeForward}
          onPress={() => actions['bring-forward'].onSelect()}
        >
          Forward
        </Button>
        <Button
          variant="secondary"
          size={isMobile ? 'lg' : 'md'}
          frontIcon={ArrangeToFront}
          onPress={() => actions['bring-to-front'].onSelect()}
        >
          To Front
        </Button>
        <Button
          variant="secondary"
          size={isMobile ? 'lg' : 'md'}
          frontIcon={ArrangeBackward}
          onPress={() => actions['send-backward'].onSelect()}
        >
          Backward
        </Button>
        <Button
          variant="secondary"
          size={isMobile ? 'lg' : 'md'}
          frontIcon={ArrangeToBack}
          onPress={() => actions['send-to-back'].onSelect()}
        >
          To Back
        </Button>
      </div>
    </div>
  )
}

const Position = track(() => {
  const editor = useEditor()
  const selectedShapes = editor.getSelectedShapes()

  return (
    <>
      <Alignment />
      {selectedShapes.filter((shape) => !['frame', 'video'].includes(shape.type)).length === 1 && <Rotation />}
      <Order />
    </>
  )
})

export { Position }
